import VCambioPasajero from "./VCambioPasajero"
import Solicitudes from "./Solicitudes"
import { Grid, Tabs, Tab, AppBar } from "@material-ui/core"
import { useEffect } from "react"
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import GroupAddIcon from '@material-ui/icons/GroupAdd'
import { useDispatch, useSelector } from "react-redux"
import { consultaSolicitudesPasajeroAction, changeCambioPasajeroTapAction } from "../../../ducks/cambiosDuck"
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive'

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    )
}
function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    }
}
const CambioPasajeros = () => {
    const { cliente, solicitudesPasajeros, tapCambioPasajero } = useSelector(store => store.cambios)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(consultaSolicitudesPasajeroAction({ IdPaquete: cliente?.paquete?.Id_Paquete }))
    }, [dispatch, cliente?.paquete?.Id_Paquete])

    const handleChange = (event, newValue) => {
        dispatch(changeCambioPasajeroTapAction({ tapValue: newValue }))
    }

    return (
        <Grid item xs={12}>
            <AppBar position="static" color="secondary">
                <Tabs
                    value={tapCambioPasajero}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="on"
                    indicatorColor="primary"
                    aria-label="scrollable force tabs example"
                >
                    <Tab
                        label="Solicitudes"
                        icon={(solicitudesPasajeros.IdSolicitudAgregarPasajeros > 0) ? <NotificationsActiveIcon /> : <NotificationsNoneIcon />}
                        {...a11yProps(0)}
                        value={0}
                    />
                    <Tab
                        label="Agregar / Quitar"
                        icon={<GroupAddIcon />}
                        {...a11yProps(1)}
                        value={1}
                    />
                </Tabs>
            </AppBar>
            <TabPanel value={tapCambioPasajero} index={0}>
                <Solicitudes />
            </TabPanel>
            <TabPanel value={tapCambioPasajero} index={1}>
                <VCambioPasajero />
            </TabPanel>
        </Grid>
    )
}
export default CambioPasajeros